
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('example-component', require('./components/ExampleComponent.vue'));
Vue.component('interest-form', require('./components/InterestForm.vue'));
Vue.component('testimonials-home', require('./components/TestimonialsHome.vue'));


const app = new Vue({
    el: '#app'
});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js